import CollectionPayload from '@libraries/api/news-crawler';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { IFetchData, initialList } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { IResponseNewsCrawler } from '@interfaces/iresponse-news-crawler';
import { IResponseNewsMedia } from '@interfaces/iresponse-news-media';
import { IMetaData } from '@interfaces/imeta-data';
import { IParamGetNewsCrawler, IParamUpdateNewsCrawler } from '@interfaces/iparam-news-crawler';

const initialData = initialList.data;
const initialMeta = initialList.meta;
const defaultPage: number = 1;

export default function useAction() {
    const [isLoaderData, setIsLoaderData]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);
    const [isLoaderNewsMedia, setIsLoaderNewsMedia]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);
    const [updateNewsCrawlerValues, setUpdateNewsCrawlerValues]: [IParamUpdateNewsCrawler, Dispatch<IParamUpdateNewsCrawler>] = useState({})

    const [data, setData]: [
        IResponseNewsCrawler[],
        Dispatch<SetStateAction<IResponseNewsCrawler[]>>,
    ] = useState(initialData);

    const [sources, setSources]: [
        IResponseNewsMedia[],
        Dispatch<SetStateAction<IResponseNewsMedia[]>>
    ] = useState(initialData)

    const [metaData, setMeta]: [
        IMetaData,
        Dispatch<SetStateAction<IMetaData>>,
    ] = useState(initialMeta);

    const [detail, setDetail]: [
        IResponseNewsCrawler | undefined,
        Dispatch<SetStateAction<IResponseNewsCrawler>>,
    ] = useState();

    const [selectedRow, setSelectedRow] = useState([])

    const getData = async (params: IParamGetNewsCrawler) => {
        const payload: IFetchData = CollectionPayload.read(params);
        setIsLoaderData(true);

        try {
            const response: any = await FetchData({ ...payload });
            setData(response.data.data);
            setMeta(response.data.meta);
            setIsLoaderData(false);
        } catch (error) {
            const { response } = error;
            setData(initialData);
            setMeta(initialMeta);
            setIsLoaderData(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const updateData = async (params: IParamUpdateNewsCrawler) => {
        const payload: IFetchData = CollectionPayload.update(params);
        setIsLoaderData(true);

        try {
            const response: any = await FetchData({ ...payload });
            response.data.data?.map((othermedia: any) => {
                const index = data.findIndex(val => val.id === othermedia.id)
                data[index] = othermedia
            })

            setData(data)
            setIsLoaderData(false);
        } catch (error) {
            const { response } = error;
            setIsLoaderData(false);
            notification.error({
                description: response ? response.data.message : "gagal memperbaharui data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getDetail = async (id: string) => {
        const payload: IFetchData = CollectionPayload.readOne(id);
        setIsLoaderData(true);

        try {
            const response: any = await FetchData({ ...payload });
            setDetail(response.data.data);
            setIsLoaderData(false);
        } catch (error) {
            const { response } = error;
            setIsLoaderData(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getSources = async () => {
        const payload: IFetchData = CollectionPayload.readNewsMedia();
        setIsLoaderNewsMedia(true);

        try {
            const response: any = await FetchData({ ...payload });
            setSources(response.data.data);
            setIsLoaderNewsMedia(false);
        } catch (error) {
            const { response } = error;
            setSources(initialData);
            setIsLoaderNewsMedia(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil list sources",
                duration: 5,
                message: 'Failed',
            });
        }
    }

    const manualFetch = async (params: any) => {
        const manualFetch = CollectionPayload.manualFetch()
        setIsLoaderData(true);
        try {
            const response: any = await FetchData({ ...manualFetch });
            setIsLoaderData(false);
            notification.success({
                description: response ? response.data.message : "penarikan data sedang diproses",
                duration: 5,
                message: 'Success',
            });
        } catch (error) {
            const { response } = error;
            setData(data);
            setMeta(metaData);
            setIsLoaderData(false);
            notification.error({
                description: response ? response.data.message : "gagal melakukan penarikan data",
                duration: 5,
                message: 'Failed',
            });
        }
    }

    return {
        data,
        defaultPage,
        getData,
        isLoaderData,
        setIsLoaderData,
        metaData,
        getDetail,
        detail,
        sources,
        setSources,
        getSources,
        isLoaderNewsMedia,
        setIsLoaderNewsMedia,
        manualFetch,
        setData,
        setSelectedRow,
        selectedRow,
        updateNewsCrawlerValues,
        setUpdateNewsCrawlerValues,
        updateData
    };
}



// WEBPACK FOOTER //
// ./src/pages/news-crawler/hooks/useAction.tsx